<!-- 雇员清单 -->
<template>
  <div class="card">
    <h2 class="title">添加人员清单</h2>
    <a-row :gutter="24">
      <div class="table-box">
        <a-table :pagination="false" :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }" :columns="columns" :data-source="salInsuredList" :scroll="{ x: 1600 }">
          <div slot="plan" slot-scope="text, records">
            <a-select v-model="records.plan" style="width:200px;" @change="priceComputed">
              <a-select-option v-for="i in riskInfos.length" :key="i" :value="'保障计划'+i">保障计划{{i}}</a-select-option>
            </a-select>
          </div>
          <span slot="num" slot-scope="text, records, index">
            {{Number(index) + 1 }}
          </span>
          <span slot="idType" slot-scope="idType">{{ $tools.codeToValue(idTypeOptions, idType, 'value', 'name') }}</span>
          <span slot="occulevel" slot-scope="occulevel">{{ handocculevel(occulevel) }}</span>
          <span slot="gender" slot-scope="gender">{{
            gender == "M" || gender == "男" ? "男" : "女"
          }}</span>
        </a-table>
      </div>
      <div class="flex justify-center btn-box">
        <a
          @click="$tools.downloadFile('https://image.ssish.com/static/product/MedilinkGroupZRY/uploadMedilinkGroupZRY.xls')"
          class="btn_a" v-if='!userBol'
          >点击下载被保险人批量导入excel文件模版</a
        >
        <a-upload name="file" v-if='!userBol' :showUploadList="false" action="/api/salQuotation/parseInsuredExcelZRY" @change="handleFileChange">
          <a-button icon="upload"> 批量上传 </a-button>
        </a-upload>
        <a-button icon="delete" v-if='!userBol' @click="delTele"> 批量删除 </a-button>
        <!-- <a-button icon="copy" v-if='!userBol' @click="visibleStick = true"> 粘贴名单 </a-button> -->
        <div class="baoxian-num">被保险人共：{{salInsuredList.length}}人</div>
        <div class="baoxian-num">保费：{{baseInfo.totalPremium || '0'}}元</div>
      </div>
    </a-row>
    <div class="_center">
      <a-button type="primary" @click="saveData">保存并生成投保资料</a-button>
      <!-- <a-button type="primary">完成投保</a-button> -->
    </div>
    <!-- 粘贴名单 -->
    <a-modal class="myModal_" width="1021px" title="粘贴名单数据" forceRender v-model="visibleStick" @ok="handleStick"
      okText="确定" cancelText="关闭">
      <div class="flex_">
        <span :style="{ color: 'red' }">*</span>
        <div style="display: inline-block">
          字段与字段直接用空格隔开，时间格式支持2018-01-01或2018/01/01。<font color="red">（切记每一项文本之间不能有空格，多个请用换行符（回车）分割。）</font>
        </div>
        <div style="margin-bottom: 8px; padding-left: 6px">
          例如：AA 身份证 110101199503076153 1990-01-01 女 机关内勤
        </div>
      </div>
      <textarea v-model="stickData" name="stickArea" id="stickArea" cols="30" rows="12"
        :style="{ width: '100%' }"></textarea>
    </a-modal>
    <a-modal v-model="filterShow" title="不合格投保人" :closable="false">
      <template slot="footer">
        <a-button key="submit" type="primary" @click="hideModal">
          确认
        </a-button>
      </template>
      <p v-for="(item, index) in filterArray" :key="index" v-html="item"></p>
    </a-modal>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  // import dictOptions from "@/views/dictOptions";
  import utils from "./../js/utils";
  const dictOptions = window.viewsdictOptions;
  import { salInsuredListMixins } from '@/mixins/salInsuredListMixins.js';
  import moment from "moment";
  export default {
    //import引入的组件需要注入到对象中才能使用
    mixins: [salInsuredListMixins],
    props: {
      columns: {
        default: () => utils.columns
      },
      baseInfo: {
        type: Object,
        default: () => {}
      },
      riskInfos: {
        type: Array,
        default: () => []
      },
      salInsuredInlist: {
        type: Array,
        default: () => []
      }
    },
    data() {
      //这里存放数据
      return {
        salInsuredList: [],
        leibie: 1,
        filterShow: false,
        filterArray: [], //被过滤的数组
        addBol: true,
        selectedRows: [], //选中的人员
        selectedRowKeys: [], //选中的人员
        visibleStick: false, //粘贴名单
        stickData: "", //粘贴的内容
        idTypeBol: false,
        userBol: false,
        addInsured: {
          name: "", //姓名
          idType: "", //证件类别
          idNumber: "", //证件号码
          birthDate: null, //出生日期
          gender: "", //性别
          occupation: [],
          occulevel: "", //职业类别
          occupationCode: "", //职业类别代码
          occupationName: "", //职业类别名称
        },
        sexOptions: dictOptions.sexOptions,
        idTypeOptions: utils.IdTypeOptions,
      };
    },
    //监听属性 类似于data概念
    computed: {
      rowSelection() {
        return {
          onChange: (selectedRowKeys, selectedRows) => {
            this.selectedRows = selectedRows;
          },
        };
      },
    },
    //监控data中的数据变化
    watch: {
      filterArray(val) {
        this.filterShow = val && val.length > 0;
      },
    },
    mounted() {
      this.salInsuredList = this.$lodash.cloneDeep(this.salInsuredInlist)
    },
    //方法集合
    methods: {
      moment,
      // 保存
      saveData() {
        this.$emit("saveGroupPremium");
      },
      // 算费 过滤用有人数的计划去算费
      priceComputed(noValiadte = true) {
        return new Promise((resolve) => {
          if(! this.salInsuredList || !this.salInsuredList.length) {
            this.handleError(noValiadte, "请先添加被保人员");
            resolve(false)
            return false;
          }
          if(this.salInsuredList.length < 3) {
            this.handleError(noValiadte, "最低投保人为3人");
            resolve(false)
            return false;
          }
          let riskInfo = this.$lodash.cloneDeep(this.riskInfos), noMultItem = [];
          riskInfo.forEach((item, index) => {
            item.insList = undefined;
            item.rno = index + 1 + '';
            item.r_mult = 0
            for(let i = 0; i < this.salInsuredList.length; i ++) {
              if(this.salInsuredList[i].plan === '保障计划'+(index+1)) {
                this.salInsuredList[i].smokeStatus = item.rno
                item.r_mult ++;
              }
            }
          })
          riskInfo = riskInfo.filter((item, index) => {
            if(item.r_mult && item.r_mult > 0) {
              return true;
            }
            noMultItem.push('保障计划'+(index+1))
          })
          // 未录入投保人数的计划过滤掉 然后做不阻断提示
          if(noMultItem && noMultItem.length) {
            this.handleError(noValiadte, noMultItem.join(',')+'未添加投保人数，未加入算费信息中');
          }
          // 人员试算，shisuan默认传1
          this.$emit("priceComputed", {total_mult: this.salInsuredList.length, riskInfos: riskInfo, insList: this.salInsuredList, shisuan: "1"});
          resolve(true)
        })
      },
      // 算费提示信息处理
      handleError(noValiadte, errorMsg){
        if(noValiadte || !errorMsg){
          return;
        }
        this.$message.error(errorMsg);
      },
      // 关闭粘贴名单弹窗
      hideModal() {
        this.filterShow = false;
        this.filterArray = [];
      },
      // 选择被保人
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      //批量删除
      delTele() {
        if (!this.selectedRowKeys.length) {
          this.$message.error("请选择要删除的被保人");
          return;
        }
        // 删除被保人
        this.salInsuredList = this.salInsuredList.filter((item, index) => {
          return this.selectedRowKeys.indexOf(index) < 0;
        });
        this.$nextTick(() => {
          this.priceComputed();
        })
        this.selectedRowKeys = [];
      },
      //粘贴
      handleStick() {
        if (!this.stickData) {
          this.$message.error("您还没有任何输入！");
          return;
        }
        var allArr = this.stickData
          .replace(/\n/g, "#")
          .split("#")
          .filter((e) => e != "");
        allArr.forEach((e) => {
          let arr = e.trim().split(/\s+/g);
          let obj = {};
          debugger
          if (this.leibie != arr[7].slice(0,1)) {
            this.filterArray.push(
              `被保人“${arr[0]}”身份证为“${arr[2]}”的类别为<font color="red">${arr[7]}类</font>，您目前选择的是<font color="red">${this.leibie}类</font>产品，只能录入职业为<font color="red">${this.leibie}类</font>的被保人，请检查后重新上传！`
            );
            return
          }
          let code = this.occCode.allCode;
          if (code.indexOf(arr[5]) <= -1) {
            this.filterArray.push(
              `被保人“${arr[0]}”身份证为“${arr[2]}”的行业code为<font color="red">${arr[5]}</font>不存在，请检查后重新上传！`
            );
            return;
          }
          if (!this.$regTest.checkIdCard(arr[2]) && arr[1] == '身份证') {
            this.filterArray.push(
              `被保人“${arr[0]}”身份证为“${arr[2]}”的身份证有误，请检查后重新上传！`
            );
            return;
          }
          let refuseCode = this.occCode.refuseCode;
          if (refuseCode.indexOf(arr[5]) > -1) {
            this.filterArray.push(
              `被保人“${arr[0]}”身份证为“${arr[2]}”的行业code为<font color="red">${arr[5]}</font>是拒保行业，请检查后重新上传！`
            );
            return;
          }
          let age = moment().diff(arr[3], "years");
          if (age < 16 || age > 65) {
            this.filterArray.push(
              `被保人“${arr[0]}”身份证为“${arr[2]}”的年龄为<font color="red">${age}</font>，不在16-65周岁之间，请检查后重新上传！`
            );
            return;
          }
          arr[6] = this.filterName([
            arr[5].substring(0, 3),
            arr[5].substring(0, 5),
            arr[5],
          ])
          arr.unshift('')
          this.columns.forEach((e, i) => {
            obj[e.dataIndex] = arr[i];
          });
          console.log(obj, this.salInsuredList, "obj=============");
          obj.idType = utils.filterAllINTYPE(obj.idType)
          this.$emit("addSelect", obj);
          this.salInsuredList.push(obj);
        });
        this.$nextTick(() => {
          this.priceComputed();
        })
        this.stickData = "";
        this.visibleStick = false;
      },
      //批量上传
      handleFileChange(info) {
        // this.filterArray = []
        // 文件导入
        if (info.file.status === "done") {
          let length = this.salInsuredList.length;
          let newArr = [];
          info.file.response.content.forEach((item, index) => {
            // console.log(this.filterArray);
            let obj = {
              index: index + length,
              type: "C", // 固定值
              ...item
            };
            if (!this.$regTest.checkIdCard(obj.idNumber) && obj.idType == '01') {
              this.filterArray.push(
                `被保人“${item.name}”身份证为“${item.idNumber}”的身份证有误，请检查后重新上传！`
              );
              return;
            }
            newArr.push(obj);
          });
          this.salInsuredList = this.salInsuredList.concat(newArr);
          this.$nextTick(() => {
            this.priceComputed();
          })
        } else if (info.file.status === "error") {
          this.$message.error(`${info.file.name} 文件导入失败，请重试！`);
        }

        // console.log(this.data);
      },
      filterSex(val) {
        //性别过滤
        return val == "男" ? "M" : "F";
      },
    },
  };
</script>
<style lang="scss" scoped>
  .justify-center{
    justify-content: center;
  }
  .btn-box {
    margin: 20px 0;
  }

  .btn-box button {
    margin: 0 20px;
    border: 1px solid #fe8f2d;
    color: #fe8f2d;
  }

  .btn-top-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn-top-box button {
    margin: 0 0 10px 20px;
    border: 1px solid #fe8f2d;
    color: #fff;
  }

  .baoxian-num {
    font-size: 16px;
    font-weight: bold;
    margin-right: 20px;
  }
  ._center{
    text-align: center;
  }
</style>